import React, { useState, useEffect, useRef } from 'react'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { withRouter } from 'react-router-dom'
import LoginIcon from './writer-login-art.svg'
import StudioLogo from '../Images/StudioLogo'
import { saveSession, getTokenAndUid, convertUrlToHttps, handlePageLoadEventLog, makePlatformStringFromDeviceInfo, redirectDeeplink, checkForGlobalLogin } from '../../lib/utils'
import { get, post } from '../../lib/api'
import Loader from '../Loader'
import { AccountContext } from '../../providers/accountProvider'
import { menuItemObj } from '../PrivatePage'
import { Box } from '../../designSystem'
import { handleEventLog, handleFacebookEvents } from '../../lib/utils'
import { notifyBugsnag } from '../ErrorBoundary'
import {
  Container,
  MainDiv,
  LeftDiv,
  RightDiv,
  IconHolder,
  LogoHolder,
  ContactUsDiv,
  ContactUsButton,
  MessageDiv,
  ErrorMessageDiv,
  HomeRedirectButton,

} from './styles'
import LoginPage from './LoginPage'
import OtpPage from './OtpPage'
import PublicPageBackButtonNavbar from '../PublicPage'
import RegisterPage from './RegisterPage'

const otpCountdownFrom = 20

const Welcome = ({history, onUpdateUser}) => {
  const [view, changeView] = useState('login') // 'login', 'otp', 'register'
  const [loader,setLoader]=useState(true);
  const [verifyFirebase, setVerifyFirebase] = useState(false)
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('')
  const [isOtpResent, setIsOtpResent] = useState(false)
  const [fullName, updateFullName] = useState('')
  const [email, updateEmail] = useState('')
  const [langPref, updateLangPref] = useState('')
  const [accountType, updateAccountType] = useState('Author')
  const [phoneError, setPhoneError] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)
  const [isOtpResendProcessing, setIsOtpResendProcessing] = useState(false)
  const [isOtpProcessing, setIsOtpProcessing] = useState(false)
  const [isLoginApiProcessing, setIsLoginApiProcessing] = useState(false)
  const [secondsRemaining, setSeconds] = useState(otpCountdownFrom)
  const [otpError, setOTPError] = useState(false)
  const [isRegisterProcessing, setIsRegisterProcessing] = useState(false)
  const [isRegisterSubmitted, setIsRegisterSubmitted] = useState(false)
  const [tempSessionInfo, setTempSessionInfo] = useState(null)
  const [hearAboutUs,setHearAboutUs]=useState('');
  const whatsAppFlag = useRef()
  const [apiError, setApiError] = useState({
    type: '',
    message: ''
  })
  const isMobile = window.screen.width < 600;
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const referrer = params.get("referrer");
  const verificationToken = params.get("token");
  const redirectTo = params.get('redirect_to')
  const resetPasswordToken = params.get("reset-password-token");
  const [isWhatAppCheck, setIsWhatappCheck] = useState(0)
  useEffect(() => {
    if (view !== 'otp') return
    if (secondsRemaining) setTimeout(() => setSeconds(secondsRemaining - 1), 1000)
  })

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const phoneNumber = query.get('phone')
    if(phoneNumber) setPhone(phoneNumber)
    handlePageLoadEventLog('login')
  },[])

  const handleForGlobalLogin = async (noRedirect) => {
    try {
      const result = await checkForGlobalLogin()
      const origin = params.get("origin")
      const userTag = params.get("user_tag")
      if (result.countryCode !== 'IN') {
        if(origin && origin.toLowerCase().includes('pfm_android')){
          localStorage.setItem('referrer',`pfm_android_PWA_global`)
        }else if(origin && origin.toLowerCase().includes('pfm_ios')){
          localStorage.setItem('referrer',`pfm_IOS_PWA_global`)
        }else if(origin && origin.toLowerCase().includes('android')){
          localStorage.setItem('referrer',`android_PWA_global${userTag ? '_' : ''}${userTag || ''}`)
        }else if(origin && origin.toLowerCase().includes('ios')){
          localStorage.setItem('referrer',`IOS_PWA_global${userTag ? '_' : ''}${userTag || ''}`)
        }
        if(!noRedirect){
          history.push('/globalLogin')
        }

      } else {
          if(origin && origin.toLowerCase().includes('pfm_android')){
            localStorage.setItem('referrer',`pfm_android_PWA_India`)
          }else if(origin && origin.toLowerCase().includes('pfm_ios')){
            localStorage.setItem('referrer',`pfm_IOS_PWA_India`)
          }else if(origin && origin.toLowerCase().includes('android')){
            localStorage.setItem('referrer',`android_PWA_India${userTag ? '_' : ''}${userTag || ''}`)
          }else if(origin && origin.toLowerCase().includes('ios')){
            localStorage.setItem('referrer',`IOS_PWA_India${userTag ? '_' : ''}${userTag || ''}`)
          }
          setLoader(false);
        }
    } catch (error) {
      setLoader(false)
    }
  }

  useEffect(() => {
    async function checkDetails() {
      const uid = params.get("uid");
      if(verificationToken && uid){
        setLoader(false)
        setIsRegisterProcessing(true)
        await handleForGlobalLogin(true)
        get('/user_api/user.get_creator_details?is_novel=1',{
          headers:{
            'access-token':verificationToken,
            uid
          }
        }).then(res => {
          const { result } = res;
          const { fullname , phone_number, email, image_url } = result
          const sessionInfo ={
            name: fullname,
            token: verificationToken,
            phone: phone_number || email,
            'image_url': convertUrlToHttps(image_url),
            uid,
          }
          if(result.account_type){
            saveSession(sessionInfo)
            redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
          }else{
            get(`/user_api/user.get_details?uid=${uid}&is_novel=1`,{
              headers:{
                'access-token':verificationToken,
                uid
              }
            }).then(response => {
              const { result } = response;
              const { language } = result[0] || {}
              fullname && updateFullName(fullname)
              language && updateLangPref(language)

              const referrer = localStorage.getItem('referrer')

              const creatorData = {
                account_type: accountType, 
                languages: language, 
                fullname: fullname, 
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,source_platform:'writers',
                device_id: localStorage.getItem('uuid'),
              }
              if(referrer !== 'url'){
                creatorData.referrer = `${referrer}_${makePlatformStringFromDeviceInfo()}`
              }

              post('/user_api/user.create_creator_account?is_novel=1', {
                data: creatorData,
                headers: {
                  uid,
                  'access-token': verificationToken,
                  'device-type':isMobile?'Mobile':'Desktop'
                },
              }).then(() => {
                onUpdateUser({account_type: accountType})
                setIsRegisterProcessing(false)
                saveSession(sessionInfo)
                handleEventLog('register','signup_sucess',{phone_number :phone_number, button: 'auto-login', route : window.location.pathname,uid})
                handleFacebookEvents(false)
                redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
              }).catch((e) => {
                console.error(e)
                setIsRegisterProcessing(false)
                handleEventLog('register','signup_fail',{phone_number :phone_number, button: 'auto-login', route : window.location.pathname,uid})
                onUpdateUser({account_type: accountType})
                saveSession(sessionInfo)
                notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, uid, when: 'auto-login-create-creator-account', ...creatorData})
                redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
              })
            }).catch((e) => {
                console.error(e)
                setIsRegisterProcessing(false)
                handleEventLog('register','signup_fail',{phone_number :phone_number, button: 'auto-login', route : window.location.pathname,uid})
                onUpdateUser({account_type: accountType})
                saveSession(sessionInfo)
                notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, when: 'auto-login-get-user-data'})
                redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
            })
          }
        }).catch((e) => {
          console.error(e)
          setIsRegisterProcessing(false)
          setApiError({type: 'afterVerify', message: 'Something went wrong while setting up your account.'})
          notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, uid, when: 'auto-login-get-creator-data'})
        })
      }
      else{
        if(verificationToken){
          window.localStorage.setItem("verification",verificationToken);
          if(referrer) window.localStorage.setItem("referrer",referrer);
          let url = "/verify-token.html";
          if(referrer) url +=("?referrer="+referrer)
          window.location.href = url;
          return;
        }
        if(resetPasswordToken){
          window.localStorage.setItem("resetPasswordToken",resetPasswordToken);
          history.push('/reset-password');
          return;
        }
        const { uid } = getTokenAndUid()
        if (uid) {
          if(referrer && referrer.includes("contest"))
            window.location.href=`/shows/novels/?referrer=${referrer}&open-new=1`;
          else
          redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
          return
        }
        else
          handleForGlobalLogin();
      }
    }
    checkDetails()
  }, [])
  
  const handlePhoneInputChange = (text) => {
    setPhoneError('')
    setPhone(text);
  }

  const handleNameInputChange = text => {
    updateFullName(text);
  }

  const handleEmailInputChange = text => {
    updateEmail(text);
  }

  const handleHearAboutUs=text=>{
    setHearAboutUs(text);
  }

  const checkInputValidity = () => {
    setPhoneError('')
    // if (phone.length !== 10 || !phone.match(/[0-9]+$/)) {
    //   setPhoneError('incorrect phone number')
    //   return false
    // }
    if (!isValidPhoneNumber('+' + phone)) {
      setPhoneError('incorrect phone number')
      return false
    }
    return true
  }
  const handlePhoneOtpRequestSend = (isResendRequest) => {
    if (isOtpResendProcessing && isResendRequest) return
    setIsOtpResent(false)
    // send otp to verify number
    if (isResendRequest) {
      setIsOtpResendProcessing(true)
    }

    // let plivoSupportedCountryCodes = []
    const plivoSupportedCountryCodes = ['+91', '+880', '+234', '+1']
    const phoneNumber = (phone.startsWith('+') ? '' : '+') + phone
    const status = plivoSupportedCountryCodes.findIndex((countryCode) => {
      return phoneNumber.startsWith(countryCode)
    }, phoneNumber)
    setIsWhatappCheck(whatsAppFlag.current?.checked ? 1 : 0)
    if ((status === -1)) {
      // firebaseLogin(phoneNumber, isResendRequest)
    } else {
      const otpRequestApi = '/user_api/user.send_otp?is_novel=1'
      get(otpRequestApi, {
        params: {
          phone_number: phoneNumber,
          channel: isResendRequest ? 'whatsapp' : null,
        }
      })
        .then(() => {
          if (isResendRequest) {
            setIsOtpResent(true)
            setIsOtpResendProcessing(false)
          }
          setIsProcessing(false)
          setSeconds(otpCountdownFrom)
          changeView('otp')
          handlePageLoadEventLog('otp', {phone_number: phone})
        })
        .catch((e) => {
          console.error(e)
          notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, phone: phoneNumber})
          if (isResendRequest) {
            setIsOtpResendProcessing(false)
          }
          redirectDeeplink(history,redirectTo)
          setIsProcessing(false)
          setApiError({ type: 'beforeVerify', message: 'Failed to send otp' })
        })
    }
  }
  const handleOtpCheck = () => {
    // prevent multiple clicks submit
    if (isOtpProcessing) return
    if (otp.length !== 6) return
    setIsOtpProcessing(true)
    // verify number by checking otp here
    setOTPError(false)
    const phoneNumber = (phone.startsWith('+') ? '' : '+') + phone
    const body = {
      phone_number: phoneNumber,
      otp: otp,
    }
    if (verifyFirebase) {
      window.confirmationResult
      .confirm(otp)
      .then(() => {
        setIsOtpProcessing(false)
        handleLogin()
      })
      .catch(() => {
        setIsOtpProcessing(false)
        setApiError({ type: 'beforeVerify', message: 'Failed to verify the otp' })
      })
      setVerifyFirebase(false)
    } else {
      handleEventLog('login','button_click',{phone_number:phone,route : window.location.pathname + window.location.search,button: 'otp_verify_button'})

      const otpVerifyApi = '/user_api/user.verify_otp?is_novel=1'
      // TODO: remove this hardcoding once apis are deployed in qa and prod
      post(otpVerifyApi, {data: body })
      .then((res) => {
        setIsOtpProcessing(false)
        if (res.status === 1) {
          handleLogin()
        } else setOTPError(true)
      })
      .catch((e) => {
        console.error(e)
        setIsOtpProcessing(false)
        setApiError({ type: 'beforeVerify', message: 'Failed to verify the otp' })
        notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, phone: phoneNumber})
      })
    }
  }
  const handleSmsLogin = () => {
    // handle multiple submit clicks
    if (isProcessing) return
    const validity = checkInputValidity()
    if (!validity) return
    setIsProcessing(true)
    handlePhoneOtpRequestSend()
    handleEventLog('login','button_click',{phone_number: phone,route : window.location.pathname + window.location.search,button: 'phone_number_button'})
  }
  const handleChangeOtp = otp => {
    setOtp(otp)
  }


  const handleRegisterFormSubmit = () => {
    // handle multiple submit clicks
    if (isRegisterProcessing) return
    setIsRegisterSubmitted(true) // this is to show register form errors on submit click, doesnt needed to be reset back
    const isValid = validateFields()
    if (!isValid) return

    setIsRegisterProcessing(true)

    const { uid, token } = tempSessionInfo || {}
    if (!uid) return
    handleEventLog('register_user','button_click',{account_type: accountType, languages: langPref.toLowerCase(),fullname: fullName,email,route : window.location.pathname + window.location.search,button: 'register_button',uid})

    // send username to update user api
    const phoneNumber = (phone.startsWith('+') ? '' : '+') + phone
    const userData = {
      view: 'dashboard',
      fullname: fullName,
      email: email,
      location: 'IN'
    }
    if(phoneNumber !== '+'){
      userData.phone_number =  phoneNumber
    }
    const referrer = localStorage.getItem('referrer')
    const creatorData = {
      account_type: accountType, languages: langPref.toLowerCase(), fullname: fullName, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,source_platform:'writers', device_id: localStorage.getItem('uuid')
    }
    if(referrer !== 'url'){
      creatorData. referrer = referrer
    }
    else{
      if(hearAboutUs!=='')
        creatorData. referrer=hearAboutUs;
    }
    post('/user_api/user.update?is_novel=1', { data: userData, headers: { uid, 'access-token': token } })

    post('/user_api/user.create_creator_account?is_novel=1', {
      data: creatorData,
      headers: {
        uid,
        'access-token': token,
        'device-type':isMobile?'Mobile':'Desktop'
      },
    }).then(() => {
      onUpdateUser({account_type: accountType})
      setIsRegisterProcessing(false)
      tempSessionInfo && saveSession({...tempSessionInfo, name: fullName})
      handleEventLog('register','signup_sucess',{phone_number:phone,route : window.location.pathname + window.location.search,uid})
      handleFacebookEvents(false)
      if(referrer && referrer.includes("contest"))
        window.location.href=`/shows/novels/?referrer=${referrer}&open-new=1`;
      else
        redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
    }).catch(e => {
      console.error(e)
      setIsRegisterProcessing(false)
      handleEventLog('register','signup_fail',{phone_number:phone,route : window.location.pathname + window.location.search,uid})
      console.log(e)
      notifyBugsnag(e.message || 'unknown api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, uid, when: 'normal account create', ...creatorData})
      setApiError({type: 'afterVerify', message: 'Something went wrong while setting up your account.'})
    })
  }

  const validateFields = () => {
    return !!langPref && !!accountType && !!fullName && !!email
  }

  const handleLogin = () => {
    // call login api after number is verified
    setIsLoginApiProcessing(true)
    const phoneNumber = (phone.startsWith('+') ? '' : '+') + phone
    const loginData = {
      account_kit_access_token: otp,
      type: 'account_kit',
      phone_number: phoneNumber,
      view: 'dashboard',
      user_type: 'pugc',
      is_writer_whatsapp: isWhatAppCheck,
      device_id : localStorage.getItem('uuid')
    }
    post('/user_api/user.login?is_novel=1', { data: loginData })
      .then((response) => {
        setIsLoginApiProcessing(false)
        const { user_info = {} } = response.result[0]
        const {
          uid,
          access_token: token,
          image_url: userImageUrl,
          fullname: userName,
        } = user_info
        const isUserExist = response.result[0].already_exists

        const sessionInfo = {
          uid,
          token,
          image_url: userImageUrl,
          name: userName,
          phone: phoneNumber
        }
        if (typeof isUserExist == 'undefined' || isUserExist === 0) {
          // dont save sessioninfo to localstorage yet, wait for the user to register
          // if the user drops off at this point, no need to save userinfo to localstorage
          // otherwise user will be directly logged in next time user opens studio and wont be able to select account type
          changeView('register')
          handlePageLoadEventLog('register_form',{uid})
          setTempSessionInfo(sessionInfo)
        } else if (isUserExist === 1) {
          saveSession(sessionInfo)
          get('/user_api/user.get_creator_details?is_novel=1').then(res => {
            onUpdateUser(res.result)
            handleEventLog('login','login_success',{phone_number:phone,route : window.location.pathname + window.location.search,uid})

            if (referrer?.includes('contest'))
              window.location.href=`/shows/novels/?referrer=${referrer}&open-new=1`;
            else
              redirectDeeplink(history, redirectTo, `${menuItemObj.home}#redirectFromLogin`)
          })
        }

      }).catch((e) => {
        handleEventLog('login','login_fail',{phone_number:phone,route : window.location.pathname + window.location.search})
        setIsLoginApiProcessing(false)
        console.error(e)
        notifyBugsnag(e.message || 'login api error', {code: e.code, message: e.message || '', method: e.method, url: e.url, when: 'normal login', ...loginData})
        setApiError({type: 'afterVerify', message: e.message || 'Something went wrong while loggin in.'})
      })
  }

  const [
    nameMissing,
    emailMissing,
    accTypeMissing,
    langPrefMissing,
  ] = [
    fullName,
    email,
    accountType,
    langPref
  ].map((field) => !field && isRegisterSubmitted)

  const handleKeyPress = (e, condition ,cb) => {
    if(condition && e.key === "Enter" ){
      cb();
    }
  }

  return (
    <Container>
      {loader && 
      <Loader></Loader>}
      {!loader && 
      <MainDiv>
        <LeftDiv>
          <IconHolder>
            <img src={LoginIcon} alt=""/>
          </IconHolder>
        </LeftDiv>
        <RightDiv>
          <LogoHolder>
            {!isMobile && <StudioLogo />}
          </LogoHolder>

          {view === 'login' && !apiError.type && !isLoginApiProcessing && (
            <LoginPage 
              phone={phone}
              phoneError={phoneError}
              handleKeyPress={handleKeyPress}
              handleSmsLogin={handleSmsLogin}
              handlePhoneInputChange ={handlePhoneInputChange}
              isValidPhoneNumber={isValidPhoneNumber}
              isProcessing={isProcessing} 
              whatsAppFlag={whatsAppFlag}
            />
          )}
          {view === 'otp' && !apiError.type && !isLoginApiProcessing && (
            <OtpPage
              otpError={otpError}
              isOtpResent={isOtpResent}
              handleChangeOtp={handleChangeOtp}
              handleKeyPress={handleKeyPress}
              handleOtpCheck={handleOtpCheck}
              otp={otp}
              isOtpProcessing={isOtpProcessing}
              phone={phone}
              secondsRemaining={secondsRemaining}
              handlePhoneOtpRequestSend={handlePhoneOtpRequestSend}
              isOtpResendProcessing={isOtpResendProcessing}
            />
          )}

          {apiError.type && (
            <ErrorMessageDiv>
              {apiError.message} click<HomeRedirectButton href={redirectTo ? `/?redirect_to=${redirectTo}` : "/"}>Here</HomeRedirectButton> to refresh
            </ErrorMessageDiv>
          )}

          {isLoginApiProcessing && !apiError.type && (
            <>
              <Loader size='md' fjordColor inline/>
              <MessageDiv>
                Please wait we are logging you in
              </MessageDiv>
            </>
          )}

          {view === 'register' && !apiError.type && !isLoginApiProcessing && (
              <RegisterPage 
                nameMissing={nameMissing}
                fullName ={fullName}
                handleNameInputChange={handleNameInputChange}
                emailMissing={emailMissing}
                email={email}
                handleEmailInputChange={handleEmailInputChange}
                langPrefMissing={langPrefMissing}
                langPref={langPref}
                updateLangPref={updateLangPref}
                referrer={referrer}
                hearAboutUs={hearAboutUs}
                handleHearAboutUs={handleHearAboutUs}
                handleRegisterFormSubmit={handleRegisterFormSubmit}
                validateFields={validateFields}
                isRegisterProcessing ={isRegisterProcessing}
                handleKeyPress={handleKeyPress}
            />
            )}
          
          {view !== 'create-book' && <ContactUsDiv>
            <span>Need help?</span>
            <ContactUsButton href="mailto:writers@pocketfm.in">Contact Us</ContactUsButton>
          </ContactUsDiv>}
        </RightDiv>
      </MainDiv>
    }
    </Container>
  )
}

const WelcomePageWrapper = props => (
  <AccountContext.Consumer>
    {({ onUpdateUser, user }) => (
      <PublicPageBackButtonNavbar>
        <Welcome
          onUpdateUser={onUpdateUser}
          user={user}
          {...props}
        />
      </PublicPageBackButtonNavbar>
    )}
  </AccountContext.Consumer>
)

export default withRouter(WelcomePageWrapper)
